export const SESSION_STORE_CONSTANTS = {
  TOKEN: "controlpass-access-token",
};
